import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
export const List = forwardRef(function List({ className, ...rest }, ref) {
    return _jsx("ul", { ref: ref, className: cn('sec-list', className), ...rest });
});
export const ListItem = forwardRef(function ListItem({ className, ...rest }, ref) {
    return _jsx("li", { ref: ref, className: cn('sec-list-item', className), ...rest });
});
export const ListItemButton = forwardRef(function ListItemButton({ selected, type = 'button', className, ...rest }, ref) {
    return (_jsx("button", { ref: ref, type: type, "aria-current": selected || undefined, className: cn('sec-list-item-button', selected && 'sec-list-item-button--selected', className), ...rest }));
});
export const ListItemIcon = forwardRef(function ListItemIcon({ className, ...rest }, ref) {
    return _jsx("span", { ref: ref, "aria-hidden": "true", className: cn('sec-list-item-icon', className), ...rest });
});
export const ListItemText = forwardRef(function ListItemText({ primary, secondary, className, children, ...rest }, ref) {
    return (_jsxs("span", { ref: ref, className: cn('sec-list-item-text', className), ...rest, children: [_jsx("span", { children: primary ?? children }), secondary != null && _jsx("span", { className: "sec-list-item-text__secondary", children: secondary })] }));
});
